import cx from "clsx";
import React from "react";
import type { NumberPickerProps } from "../NumberPicker/NumberPicker";
import {
	SelectSingle,
	type SelectSingleProps,
} from "../Select/Single/SelectSingle";
import { NDSTextInput, type TextInputProps } from "../TextInput/TextInput";
import * as styles from "./EditableField.module.scss";

export type EditableFieldInputProps =
	| TextInputProps
	| SelectSingleProps
	| NumberPickerProps;
export const EditableFieldInput: React.FC<EditableFieldInputProps> = ({
	fieldType,
	...props
}) => {
	switch (fieldType) {
		case "singleSelect": {
			return <SelectSingle {...(props as SelectSingleProps)} />;
		}

		case "text": {
			return <NDSTextInput {...(props as TextInputProps)} />;
		}

		case "number": {
			const { label, value, onChange, min, max, hidden, disabled, name } =
				props as NumberPickerProps;

			return (
				<div
					key={`${hidden}-${label}`}
					className={styles.numberPicker}
					style={{ display: hidden ? "none" : undefined }}
				>
					<label htmlFor={props.name} className={styles.numberPickerLabel}>
						{label}
					</label>
					<div
						className={cx(
							styles.numberPickerOuterInputContainer,
							disabled && styles.disabled,
						)}
					>
						<span className={styles.numberPickerInputContainer}>
							<button
								type="button"
								className={styles.decrementButton}
								onClick={() => onChange(Number(value) - 1)}
								disabled={
									disabled || (min !== undefined && Number(value) <= min)
								}
								role="spinbutton"
								aria-valuemax={max}
								aria-valuemin={min}
								aria-valuenow={Number.parseInt(value)}
								hidden={hidden}
							>
								{"\u2212"}
							</button>
							<input
								type="number"
								className={styles.numberPickerInput}
								value={value}
								onChange={(e) => onChange(Number.parseInt(e.target.value, 10))}
								min={min}
								max={max}
								hidden={hidden}
								disabled={disabled}
								name={name}
							/>
							<button
								type="button"
								className={styles.incrementButton}
								onClick={() => onChange(Number(value) + 1)}
								disabled={
									disabled || (max !== undefined && Number(value) >= max)
								}
								role="spinbutton"
								aria-valuemax={max}
								aria-valuemin={min}
								aria-valuenow={Number.parseInt(value)}
								hidden={hidden}
							>
								+
							</button>
						</span>
					</div>
				</div>
			);
		}
		default:
			return null;
	}
};
